import { DDCalendarDate } from './common';

/** Defines the data type of the tab view component. */
export type FilterType = 'Contract' | 'Request';

/** Defines the tab names. */
export type FilterName = 'ApprovedContracts' | 'MyRequests' | 'PendingRequests';

export interface RangeDate {
  dateFrom: DDCalendarDate | null;
  dateTo: DDCalendarDate | null;
}

export interface ContractFilter {
  contractName: string;
  tarafTypeIds: number[];
  contractStatusIds: number[];
  issueDate: RangeDate;
  startDate: RangeDate;
  endDate: RangeDate;
  type: FilterType;
}

export interface RequestFilter {
  contractName: string;
  tarafTypeIds: number[];
  requestTypeIds: number[];
  requestStatusIds: number[];
  issueDate: RangeDate;
  type: FilterType;
}

/**
 * Creates a contract query object type with default values.
 * @param options An object contains all or parts of the contract query object type to override the default values.
 * @returns Contract query object.
 */
export function createContractFilter(options?: Partial<ContractFilter>): ContractFilter {
  const defaults: ContractFilter = {
    contractName: '',
    tarafTypeIds: [0],
    contractStatusIds: [0],
    startDate: {
      dateFrom: {} as DDCalendarDate,
      dateTo: {} as DDCalendarDate,
    },
    endDate: {
      dateFrom: {} as DDCalendarDate,
      dateTo: {} as DDCalendarDate,
    },
    issueDate: {
      dateFrom: {} as DDCalendarDate,
      dateTo: {} as DDCalendarDate,
    },
    type: 'Contract',
  };

  return { ...defaults, ...options };
}

/**
 * Creates a contract query object type with default values.
 * @param options An object contains all or parts of the contract query object type to override the default values.
 * @returns Contract query object.
 */
export function createRequestFilter(options?: Partial<RequestFilter>): RequestFilter {
  const defaults: RequestFilter = {
    contractName: '',
    tarafTypeIds: [0],
    requestStatusIds: [0],
    requestTypeIds: [0],
    issueDate: {
      dateFrom: {} as DDCalendarDate,
      dateTo: {} as DDCalendarDate,
    },
    type: 'Request',
  };

  return { ...defaults, ...options };
}
